function Configurator(){
    var $form = $(".js-configurator")
    var configuratorMan = false;
    var configuratorSpez = null;

    var stepActive = 1;
    var stepNext = 1;
    var stepBack = 1;

    var modellSwitchToMan = false;

    var stepNextAllowed = false;

    var $showAll = $form.find(".js-showall");
    var showAll = false;

    var $steps = $form.find(".js-configurator_steps");
    var $step1 = $form.find(".js-configurator_step-1");
    var $step2 = $form.find(".js-configurator_step-2");
    var $step3 = $form.find(".js-configurator_step-3");
    var $step4 = $form.find(".js-configurator_step-4");
    var $step5 = $form.find(".js-configurator_step-5");

    var $step1Con = $form.find(".js-configurator_step_con-1");
    var $step2Con = $form.find(".js-configurator_step_con-2");
    var $step3Con = $form.find(".js-configurator_step_con-3");
    var $step4Con = $form.find(".js-configurator_step_con-4");
    var $step5Con = $form.find(".js-configurator_step_con-5");

    var $hersteller = $form.find(".js-configurator_hersteller");
    var herstellerSelectedBefore = "";

    var $modell = $form.find(".js-configurator_modell");
    var $modellOptions = $modell.find("option");

    var $herstellerModellManCon = $form.find(".js-hersteller_modell_man_con");

    var $herstellerMan = $form.find(".js-configurator_hersteller-man");
    var $modellMan = $form.find(".js-configurator_modell-man");

    var $buttonBack = $form.find(".js-configurator_button-back");
    var $buttonNext = $form.find(".js-configurator_button-next");

    var $editStep1 = $(".js-edit-step1");
    var $editStep2 = $(".js-edit-step2");
    var $editStep3 = $(".js-edit-step3");
    var $editStep4 = $(".js-edit-step4");

    var $ergHersteller = $(".js-erg-hersteller");
    var $ergModell = $(".js-erg-modell");

    var $land = $(".js-land");
    var landChangeMan = false;
    var $email = $(".js-email");
    var $firmaPrivat = $(".js-firma_privat");
    var $firmaName = $(".js-firma_name");

    var dbGeraeteData = [];

    var hrefSendPdf = "";

    $ergFilter = $(".js-filter");

    $ergLand = $(".js-erg-land");
    $ergEmail = $(".js-erg-email");
    $ergFirmaPrivat = $(".js-erg-firma_privat");
    $ergFirmaName = $(".js-erg-firma_name");

    this.setConfiguratorSpez = function(configuratorSpez){
        this.configuratorSpez = configuratorSpez;
    }

    $showAll.on("click", function(e){
        e.preventDefault();
       if(!showAll){
           $form.find("[class*='js-']").show();
           showAll = true;
       }else{
           showStep1();
           $hersteller.trigger("change")
           showAll = false;
       }
    });

    // Header
    $steps.on("click", function(e){
        e.preventDefault();
        var stepNext = parseInt($(this).data("step"));
        var allow = $(this).data("allow");

        if(allow){
            if(stepNext === 1){
                showStep1();
            }else if(stepNext === 2 && configuratorMan){
                showStep2();
            }else if(stepNext === 3){
                showStep3();
            }else if(stepNext === 4){
                showStep4();
            }else if(stepNext === 5){
                showStep5();
            }
        }

        $(this).trigger("blur");
    })

    // Allg.
    toggleSteps = function(){
        showAll = false;

        $step1Con.hide();
        $step2Con.hide();
        $step3Con.hide();
        $step4Con.hide();
        $step5Con.hide();

        $buttonBack.hide();
        $buttonNext.show();

        stepNextAllowed = false;

        $steps.data("allow", 0);
        $steps.parents(".config-step").addClass("helper_ignore");

        if(stepActive > 1){
            $buttonBack.show();
            $step1.data("allow", 1).parents(".config-step").removeClass("helper_ignore");
        }
        if(stepActive > 2 && configuratorMan){
            $step2.data("allow", 1).parents(".config-step").removeClass("helper_ignore");
        }
        if(stepActive > 3){
            $step3.data("allow", 1).parents(".config-step").removeClass("helper_ignore");
        }
        if(stepActive > 4){
            $buttonNext.hide();
            $step4.data("allow", 1).parents(".config-step").removeClass("helper_ignore");
        }


        $steps.parents(".config-step").removeClass("active");

        if(stepActive === 1){
            $step1.parents(".config-step").addClass("active");
        }else if(stepActive === 2){
            $step2.parents(".config-step").addClass("active");
        }else if(stepActive === 3){
            $step3.parents(".config-step").addClass("active");
        }else if(stepActive === 4){
            $step4.parents(".config-step").addClass("active");
        }else if(stepActive === 5){
            $step5.parents(".config-step").addClass("active");
        }

        allowNext(stepNextAllowed);

        if($steps.length > 0){
            $('html, body').animate({
                scrollTop: $steps.offset().top-100
            }, 400);
        }
    }


    allowNext = function(allow){
        if(allow === false){
            $buttonNext.addClass("helper_transparent");
        }else{
            $buttonNext.removeClass("helper_transparent");
        }
        stepNextAllowed = allow;
    };

    this.allowNextExt = function(allow){
        if(allow === false){
            $buttonNext.addClass("helper_transparent");
        }else{
            $buttonNext.removeClass("helper_transparent");
        }
        stepNextAllowed = allow;
    };


    $buttonNext.on("click", function(e){
        e.preventDefault();

        if(stepNextAllowed){
            if(stepNext === 1){
                showStep1();
            }else if(stepNext === 2){
                showStep2();
            }else if(stepNext === 3){
                showStep3();
            }else if(stepNext === 4){
                showStep4();
            }else if(stepNext === 5){
                showStep5();
            }
        }

        $(this).trigger("blur");
    })

    $buttonBack.on("click", function(e){
        e.preventDefault();
        if(stepBack === 1){
            showStep1();
        }else if(stepBack === 2){
            showStep2();
        }else if(stepBack === 3){
            showStep3();
        }else if(stepBack === 4){
            showStep4();
        }else if(stepBack === 5){
            showStep5();
        }

        $(this).trigger("blur");
    })

    // Hersteller / Modell
    showStep1 = function(){
        stepBack = 0;
        stepActive = 1;
        stepNext = 2;

        toggleSteps();
        $step1Con.show();
        validateStep1();
    }

    $hersteller.on("change", function(){
        $option = $(this).find("option:selected");
        $(this).find("option").removeAttr("selected");

        if(herstellerSelectedBefore != $option.text()){
            $step1Con.find("[type='text']").attr("value", "").val("");
            $step2Con.find("[type='text']").attr("value", "").val("");
            $step2Con.find("[type='number']").attr("value", "").val("");
            $step2Con.find("[type='radio']").removeAttr("checked");

            $option.attr("selected", true);
        }

        filterModell($(this));
    });

    $modell.on("change",function(){
        validateStep1();
    });

    $herstellerMan.on("keyup", function(){
        validateStep1();
    });

    $modellMan.on("keyup", function(){
        validateStep1();
    });

    filterModell = function(){
        var value = $hersteller.find("option:selected").val();
        var hersteller = $hersteller.find("option:selected").data("hersteller");

        var someSelected = false;

        return new Promise(function(resolve, reject){
            $modell.html("");
            $modellOptions.each(function(key, element){
                var $currentElement = $(element);

                if($currentElement.attr("disabled") == "disabled"){
                    option = new Option($currentElement.text(), "-1", true, false);
                    $option = $(option).prop("disabled", true);
                    $modell.append($option);
                }

                if($currentElement.data("hersteller") == hersteller){
                    if($currentElement.attr("selected") == "selected"){
                        option = new Option($currentElement.text(), $currentElement.text(), false, true);
                        $option = $(option).data("hersteller", hersteller);
                        $option.data("oktave", $currentElement.data("oktave"))
                        $modell.append($option);
                        someSelected = true;
                    }else{
                        option = new Option($currentElement.text(), $currentElement.text(), false, false);
                        $option = $(option).data("hersteller", hersteller);
                        $option.data("oktave", $currentElement.data("oktave"))
                        $modell.append($option);
                    }
                }
            });
            resolve();
        }).then(function(){
            if(!someSelected || (herstellerSelectedBefore != "" && herstellerSelectedBefore != hersteller)){
                $modell.val("-1");
                $modell.find("option:selected").prop("selected", false);
                $modell.find("option:disabled").promise("selecetd", true);
                $modell.find("option:first-child").prop("selected", true);
            }

            if(value == "andere" || $modell.find("option:selected").data("hersteller") != hersteller || $modell.find("option:selected").val() == "-1"){
                $hersteller.parents(".js-input_group").removeClass("is-valid is-invalid");
                if(value == "andere"){
                    $herstellerModellManCon.show();
                }else{
                    $herstellerModellManCon.hide();
                }
            }else {
                $configuratorInputHersteller.val("");
                $configuratorInputModell.val("");
                $hersteller.parents(".js-input_group").addClass("is-valid");
                $herstellerModellManCon.hide();
            }
            herstellerSelectedBefore = hersteller;

            validateStep1();
        });
    }

    validateStep1 = function(){
        var valid = false;
        this.modellSwitchToMan = false;
        var $modellSelected = $modell.find("option:selected");

        $(".js-geraet_keine_oktavwerte").hide();
        if($modellSelected.val() != "-1"){
            configuratorMan = false;
            stepNext = 3;

            if(checkOktave
                && parseInt($modellSelected.data("oktave")) === 0){
                $(".js-geraet_keine_oktavwerte").show();
                this.modellSwitchToMan = true;
                configuratorMan = true;
                stepNext = 2;
            }

            valid = true;
        }else if($hersteller.find("option:selected").val() == "andere"){
            configuratorMan = true;
            stepNext = 2;

            valid = ($herstellerMan.val() != "" && $modellMan.val() != "");
        }

        allowNext(valid);
    }

    // Step2
    showStep2 = function(){
        stepBack = 1;
        stepActive = 2;
        stepNext = 3;

        if(this.modellSwitchToMan){
            $herstellerMan.val($hersteller.find("option:selected").text());
            $modellMan.val($modell.find("option:selected").text());

            $hersteller.find("[value=andere]").prop("selected", true)
            $modell.find("[value=-1]").prop("selected", true)

            $herstellerModellManCon.show();
        }


        toggleSteps();
        $step2Con.show();

        this.configuratorSpez.showStep2();
    }

    // Step3
    showStep3 = function(){
        stepBack = 2;
        if(!configuratorMan) stepBack = 1;
        stepActive = 3;
        stepNext = 4;

        loadAngabenZumGeraet();

        toggleSteps();
        $step3Con.show();
        this.configuratorSpez.showStep3();
    }

    // Step 4 / Angabe zum Projekt
    showStep4 = function(){
        stepBack = 3;
        stepActive = 4;
        stepNext = 5;

        toggleSteps();
        $step4Con.show();
        validStep4();
    }

    $step4Con.on("change", "input,select", function(){
        validStep4();
    });

    $land.on("change", function(){
       landChangeMan = true;
    });

    validStep4 = function(){
        var valid = true;

        $.each($step4Con.find("[type='checkbox']"), function(key, element){
            $currentElement = $(element);
            if(!$currentElement.is(':checked')) valid = false;
        });

        $.each($step4Con.find("[type='text']"), function(key, element){
            $currentElement = $(element);
            if($currentElement.val() === "") valid = false;
        });

        $.each($step4Con.find("[type='email']"), function(key, element){
            $currentElement = $(element);

            clearFieldValidaitonClass($currentElement)

            if($currentElement.val() == ""){
                valid = false;
            }else if($currentElement.val() != "" && !hx.isValidEmailAddress($currentElement.val())){
                setFieldValidaitonClass($currentElement, false);
                valid = false;
            }else {
                setFieldValidaitonClass($currentElement, true);
            }
        });

        $.each($step4Con.find("select").find("option:selected"), function(key, element){
            $currentElement = $(element);
            if($currentElement.val() === "") valid = false;
        });

        allowNext(valid);
    }

    // Step 5 / Ergebnisliste
    showStep5 = function(){
        stepBack = 4;
        stepActive = 5;
        stepNext = 0;

        toggleSteps();

        $(".js-ergebnis_liste").find(".js-step5_info_kein_oktavspektrum").remove();
        if($(".js-step5_info_kein_oktavspektrum").length > 0 && !octaveFilled()){
            $(".js-filter_con").hide();
            $(".js-filter_label").hide();
            $(".js-ergebnis_liste").append($(".js-step5_info_kein_oktavspektrum").clone())
        }else{
            $(".js-filter_con").show();
            $(".js-filter_label").show();
            loadErgebnisliste();
        }


        if($hersteller.find("option:selected").val() == "andere"){
            $ergHersteller.text($herstellerMan.val());
            $ergModell.text($modellMan.val());
        }else{
            $ergHersteller.text($hersteller.find("option:selected").text());
            $ergModell.text($modell.find("option:selected").text());
        }

        this.configuratorSpez.fillErgData();

        $ergLand.text($land.find("option:selected").text());
        $ergEmail.text($email.val());
        $ergFirmaPrivat.text($(".js-firma_privat:checked").data("val"));
        $ergFirmaName.text($firmaName.val());

        if(configuratorMan){
            $editStep2.show();
        }else{
            $editStep2.hide();
        }

        $step5Con.show();
    }

    function octaveFilled(){
        var octave = 0;
        $oktawerte.each(function(key, element){
            if($(this).val().toString() != "-" && $(this).val().toString() != ""){
                octave += 1
            }
        });
        return octave > 0;
    }

    $editStep1.on("click", function(e){
        e.preventDefault();
        showStep1();
    });

    $editStep2.on("click", function(e){
        e.preventDefault();
        if(configuratorMan){
            showStep2();
        }
    });

    $editStep3.on("click", function(e){
        e.preventDefault();
        showStep3();
    });

    $editStep4.on("click", function(e){
        e.preventDefault();
        showStep4();
    });

    $ergFilter.on("change", function(){
        var value = $(this).val();
        var filter = $(this).data("filter");
        $(".js-ergebnis_liste .js-tr_erg").each(function(key, row){
            $row = $(this);
           if($row.data(filter) == value || value == "*"){
               $row.show();
           } else{
               $row.hide();
            }
        });
    })

    loadAngabenZumGeraet = function(){
        dbGeraeteData = {};

        if(!configuratorMan){
            $.ajax({
                url:$form.data("ajax_geraetdetail"),
                type:'POST',
                data:$form.serialize(),
                dataType:"json",
            }).done(function(fieldValues){
                $.each(fieldValues, function(name, value){
                    $field = $("[data-name='"+name+"']");

                    if($field.attr("type") == "radio"){
                        $.each($field, function(key, element){
                            if($(element).val() == value) $(element).trigger("click");
                        });
                    } else if($field.attr("type") == "text"){
                        if(value != "0"){
                            $field.val(value);
                        }else{
                            $field.val("-");
                        }
                    }

                    dbGeraeteData[name] = value
                });
            });
        }
    }

    this.getDbGeraeteData = function(){
        return dbGeraeteData
    }

    this.getLandChangeMan = function(){
        return landChangeMan;
    }

    loadErgebnisliste = function(){
        $.ajax({
            url:$form.data("ajax_ergebnisliste"),
            type:'POST',
            dataType:'json',
            data:$form.serialize(),
        }).done(function(response){
            $(".js-ergebnis_liste").html(response.liste);
            $(".js-filter").html(response.filter);
            if (!$('html').hasClass('no-touch')) { /* Execute code only on a touch screen device */
                $('.nav-item.has-sub-menu > a').on('touchstart', function(e) {
                    $(this).parent().find('.sub-menu').toggle();
                });
                $('.table-wrapper > .table').each(function(){
                    if( $(this).width() > $(this).parent().width() && !$(this).parent().hasClass('has-scrollbar')){
                        $(this).parent().addClass('has-scrollbar');
                        $(this).parent().after('<div class="scrollbar-indicator"></div>');
                    }
                });
            }
        });
    }

    $(".js-ergebnis_liste").on("click", ".js-send_pdf", function(e){
        hrefSendPdf = $(this).attr("href")
    });

    $(".js-send_pdf_per_email").on("click", function(e){
        e.preventDefault();
        $button = $(this);
        $button.prop("disabled", true)
        $.ajax({
            url:hrefSendPdf,
            type:'POST',
            data:{pdf_to_email:$(".js-pdf_to_email").val()}
        }).done(function(html){
            $("#config-results").trigger("click");
            $button.prop("disabled", false)
        });
    });

    this.init = function(){
        showStep1();
    }
}